import type { ReportNodeSchemaLatest } from '~/adapter/indexedDB/types'
import { Image } from '~/domain/report/model/image/image'
import type { MultipleChoiceQuestionNode } from '~/domain/report/model/report/node/questionNode/multipleChoiceQuestionNode/multipleChoiceQuestionNode'
import { convertReadonlyImage, convertReportImage } from '../image/convertImage'
import { convertMemo } from './convertMemo'
import { convertToHide } from './convertToHide'

type MultipleChoiceQuestionNodeSchema = Extract<
  ReportNodeSchemaLatest['data']['nodes'][0],
  { type: 'question'; questionType: 'multipleChoice' }
>
type ImageSchema = MultipleChoiceQuestionNodeSchema['question']['images'][0]

export const convertMultipleChoiceQuestionNode = async (
  node: MultipleChoiceQuestionNode,
): Promise<MultipleChoiceQuestionNodeSchema> => {
  const images: ImageSchema[] = []
  for (const image of node.question.images) {
    if (Image.isLocalImage(image)) {
      // お絵描き編集後のローカル画像
      images.push(await convertReportImage(image))
    } else {
      images.push(await convertReadonlyImage(image))
    }
  }
  return {
    ...node,
    question: {
      ...node.question,
      images,
    },
    memo: await convertMemo(node.memo),
    hide: convertToHide(node),
  }
}
